import { ACTIONS } from '@r1-frontend/shared/constants/analytics';
import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { PolicyNote } from '@r1-frontend/ui-react/components/PolicyNote';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { POLICY_PAGE_LINK } from '~/src/constants';
import { USER_LOGIN_ROUTE } from '~/src/constants/routes';
import { dataLayerForCBPhonePush } from '~/src/helpers/eventsForDataLayer';

import useSubmitAuthForm from './hooks/useSubmitAuthForm';
import { Button, ButtonBlock, Inputs, Message, Name, Phone, Title, Wrapper } from './styled';

const AuthForm = (props) => {
    const {
        title = 'Чтобы подключить услугу, станьте клиентом Дом.ру или авторизуйтесь',
        buttonText = 'Подключиться',
        handleSuccess,
        getParams = '',
        handleAuthClick,
        isPopup = false,
        onlyBecomeClient = false,
        disableButton = false,
        option,
    } = props;

    const [phone, setPhone] = useState({});
    const [name, setName] = useState({});
    const [isValidInputs, setIsValidInputs] = useState(false);
    const [isLoadingButton, setIsLoadingButton] = useState(false);
    const [beenStarted, setDataLayer] = useState(false);

    useEffect(() => {
        setIsValidInputs(phone.isValid && name.isValid);
    }, [phone, name]);

    const [
        { status, isLoading, message },
        doSubmit,
    ] = useSubmitAuthForm(isPopup);

    const onChangeHandler = (stateInput, _setState) => {
        // @TODO stateInput.value убрать из условия после фикса nameDecorator (useEffect onchange) UI react
        if (!beenStarted && stateInput.value !== undefined) {
            dataLayerForCBPhonePush({
                action: ACTIONS.started,
                isPopup,
                requestId: null,
                option: option ?? '',
            });
            setDataLayer(true);
        }
        _setState(stateInput);
    };

    const submitHandler = e => {
        e.preventDefault();
        if (isValidInputs) {
            const params = {
                name: name.value,
                phone: phone.value,
                label: option,
            };

            if (handleSuccess) {
                handleSuccess(params);
            } else {
                doSubmit(params);
            }
        }
        setIsLoadingButton(true);
    };

    return (
        <Wrapper onSubmit={submitHandler}>
            {
                status && message
                    ? <Message>{message}</Message>
                    : <>
                        <Title>
                            {title}
                        </Title>
                        <Inputs>
                            <Name
                                name='name'
                                onChange={(stateInput) => onChangeHandler(stateInput, setName)}
                                placeholder='Как вас зовут?'
                                errorMessage='Ожидаются только буквы и дефисы'
                                className={'ym-disable-keys'}
                            />
                            <Phone
                                name='phone'
                                onChange={(stateInput) => onChangeHandler(stateInput, setPhone)}
                                placeholder='Номер телефона'
                                errorMessage='Введите телефон в формате +7 (999) 999-99-99'
                                className={'ym-disable-keys'}
                            />
                        </Inputs>
                        {!onlyBecomeClient && (
                            <IndentContainer $united={[0, 0, 12, 0]}>
                                <PolicyNote
                                    data-test='agreement'
                                    buttonText={buttonText}
                                    agreeUrl={POLICY_PAGE_LINK}
                                />
                            </IndentContainer>
                        )}
                        <ButtonBlock>
                            <Button
                                type={btnTypes.ACCENT}
                                text={buttonText}
                                disabled={!isValidInputs || isLoading || disableButton}
                                isLoading={isLoadingButton}
                            />
                            {onlyBecomeClient
                                ? <PolicyNote
                                    data-test='agreement'
                                    buttonText={buttonText}
                                    agreeUrl={POLICY_PAGE_LINK}
                                />
                                : <Button
                                    href={`${USER_LOGIN_ROUTE}${getParams}`}
                                    onClick={handleAuthClick}
                                    type={btnTypes.SECONDARY}
                                    text={'Войти'}
                                />
                            }
                        </ButtonBlock>
                    </>
            }
        </Wrapper>
    );
};

const mapStateToProps = state => ({
    cityDomain: state.city.currentCity.domain,
});

export default connect(mapStateToProps)(AuthForm);
